import { render, staticRenderFns } from "./PopupGenerated.vue?vue&type=template&id=38c997c0"
import script from "./PopupGenerated.vue?vue&type=script&lang=js"
export * from "./PopupGenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports